import Api from "../../../../lib/api";
import FormField from "../form-field";
import Select from "../select";

export default class SelectField extends FormField {
	constructor(props) {
		super(props);

		this.select = null;

		this.init();
	}

	init() {
		if (!this.$root) {
			throw new Error('SelectField: Root element is not defined!');
		}

		this.select = new Select({
			$root: this.$root.querySelector('.listbox')
		});

		super.init();
	}

	addEventListeners() {
		this.select.subscribe('valueChange', this.handleValueChange.bind(this));
	}

	handleValueChange(e) {
		this.setValue(e.detail);
		this.validateSoft();
	}

	validate() {
		this.isValid = this.value !== null;
	}

	setInitialState() {
		this.select.setInitialState();
	}

	setInitialValue(value) {
		this.select.selectOptionByValue(value);
	}
}